<template>
  <v-card
    max-width="344"
    class="mx-auto mt-6 mb-6"
    :to="{
      path: notice.link,
      query: {
        description: this.notice.description,
        capa2: this.notice.capa2,
        paragraph: this.notice.paragraph,
        title: this.notice.title,
        images: this.notice.images
      }
    }"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="headline">{{
          notice.title
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-img
      :src="
        require(`../../../../styles/drawable-info/Medidas e Manejos/${notice.capa}`)
      "
      height="194"
    ></v-img>

    <v-card-text>
      {{ notice.paragraph | truncate(100, "...") }}
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "noticeCard",
  props: {
    notice: {
      type: Object,
      required: true
    }
  }
};
</script>
